// Generated with util/create-component.js
import Alert from './Alert';

export default Alert;
